import styles from './index.module.sass';
import OrderSvg from '@/modules/mixing/images/order.svg';
import SortArrow from '@/modules/mixing/images/sort-arrow.svg';
import { Radio, Tooltip } from 'antd';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

export const Sorter = ({ sortOption, setSortOption, orderBy, setOrderBy, className }: IArgs) => {
  const popupRef = useRef<any>(null);
  const buttonRef = useRef<any>(null);
  const [active, setActive] = useState(false);

  const onSorterClick = (e: any) => {
    e.preventDefault();
    setActive(!active);
  };

  const handleClickOutside = (event: any) => {
    if (
      buttonRef.current &&
      !buttonRef.current.contains(event.target) &&
      popupRef.current &&
      !popupRef.current.contains(event.target)
    ) {
      setActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={classNames(styles.sorter, className)}>
      <span className={styles.label}>сортировать по:</span>
      <div className={styles.handler}>
        <Tooltip title="По возрастанию/по убыванию">
          <img
            src={OrderSvg}
            alt="order"
            style={{ transform: orderBy === 'asc' ? 'none' : 'scale(1, -1)' }}
            onClick={() => (orderBy === 'asc' ? setOrderBy('desc') : setOrderBy('asc'))}
          />
        </Tooltip>
        <a className={styles.button} href="#" ref={buttonRef} onClick={(e) => onSorterClick(e)}>
          <span>{sortOption.find((item) => item.active === true)?.label}</span>
          <img
            src={SortArrow}
            style={{
              transform: active ? 'rotate(0deg)' : 'rotate(180deg',
              transition: '.3',
            }}
            alt="arrow"
          />
        </a>
        <div
          className={styles.sorterPopup}
          style={{ display: active ? 'block' : 'none' }}
          ref={popupRef}
        >
          <ul className={styles.popupList}>
            {sortOption.map(({ val, label, active }) => (
              <PopupItem
                checked={active}
                label={label}
                onClick={() => {
                  setSortOption(
                    sortOption.map((item) => {
                      if (item.val === val) return { ...item, active: true };
                      return { ...item, active: false };
                    }),
                  );
                  // setTimeout(() => setActive(false), 200);
                }}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

var PopupItem = ({
  label,
  onClick,
  checked,
}: {
  label: string;
  checked: boolean;
  onClick: () => void;
}) => (
  <li className={styles.popupItem} onClick={onClick}>
    {' '}
    <Radio checked={checked} /> {label}
  </li>
);

interface IArgs {
  sortOption: { label: string; val: string; active: boolean }[];
  setSortOption: (val: { label: string; val: string; active: boolean }[]) => void;
  orderBy: 'asc' | 'desc';
  setOrderBy: (val: 'asc' | 'desc') => void;
  className?: string;
}
